@if (!isLoading) {
  <microsec-card [isBordered]="true">
    <div class="flex flex-col gap-4 w-full">
      <div class="font-bold text-xl">Edit Your Personal Information</div>
      <div class="text-gray-500">Update your name and email.</div>
      <p-divider styleClass="my-1" />
      <p-button severity="primary" [style]="{ 'text-transform': 'none' }" [rounded]="true" label="Manage in Account Console" (onClick)="openLink()" />
    </div>
  </microsec-card>
}
